(function () {
  angular.module("akitabox.ui.dialogs.document.download", [
    "ngMaterial",
    "akitabox.core.services.document",
  ]);
})();
